import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { APP_URL, FILE_URL } from '../../constants'; // Correctly import APP_URL
import { Dropdown } from 'react-bootstrap';
import { useTokens } from '../../context/TokenContext';
import NotificationBar from '../../components/templates/NotificationBar';

const Header = () => {
    const { getItem, logout } = useTokens();
    const navigate = useNavigate();
    const vendorInfo = getItem('vendor', 'UserInfo');
    const vendorAuthToken = getItem('vendor', 'AuthToken');
    const notification = getItem('vendor', 'UserNotifications') || [];

    const handleLogout = () => {
        logout('vendor', '/vendor/login');
    };

    return (
        <header className="navbar sticky-top bg-dark flex-md-nowrap p-0 shadow" data-bs-theme="dark">
            <Link to={APP_URL} className="navbar-brand col-md-3 col-lg-2 me-0 px-3 fs-6 text-white" href="#">
                Bhajjamal.com
            </Link>
            <ul className="navbar-nav flex-row d-md-none">
                <li className="nav-item text-nowrap">
                    <button className="nav-link px-3 text-white" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSearch" aria-controls="navbarSearch" aria-expanded="false" aria-label="Toggle search">
                        <i className="bi bi-search"></i> {/* Bootstrap Icon for Search */}
                    </button>
                </li>
                <li className="nav-item text-nowrap">
                    <button className="nav-link px-3 text-white" type="button" data-bs-toggle="offcanvas" data-bs-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation">
                        <i className="bi bi-list"></i> {/* Bootstrap Icon for List */}
                    </button>
                </li>
            </ul>
            <ul className="navbar-nav flex-row align-items-center me-auto d-lg-block d-none">
                <li className="nav-item text-nowrap">
                    <a className="nav-link px-3 text-white" href={APP_URL} target="_blank" rel="noopener noreferrer" aria-label="Open Store Front">
                        <i className="bi bi-box-arrow-up-right"></i> Store Front
                    </a>
                </li>
            </ul>
            <ul className="navbar-nav flex-row align-items-center">
                <li className="nav-item text-nowrap App d-flex justify-content-end p-2">
                    <NotificationBar userToken={vendorAuthToken} NotificationList={{ data: notification.notifications || [] }} totalNotificationCount={notification?.unreadCount || 0} userRole={'vendor'} />
                </li>
                <li className="nav-item text-nowrap">
                    <Dropdown align="end">
                        <Dropdown.Toggle variant="link" id="user-dropdown" className='btn text-decoration-none'>
                            <img src={`${FILE_URL}${vendorInfo?.profile_picture}`} alt="" width="32" height="32" className="rounded-circle me-2" /> Hi, {vendorInfo?.first_name} {/* User icon */}
                        </Dropdown.Toggle>
                        <Dropdown.Menu style={{ 'zIndex': '9999' }}>
                            <Dropdown.Item to="/vendor/profile" as={Link}><i className='bi bi-person'></i> Profile</Dropdown.Item>
                            <Dropdown.Item to="/vendor/profile/change-password" as={Link}><i className='bi bi-shield-lock'></i> Security</Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Item href='#' onClick={handleLogout}><i className='bi bi-box-arrow-left'></i> Logout</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </li>
            </ul>
            <div id="navbarSearch" className="navbar-search w-100 collapse">
                <input className="form-control w-100 rounded-0 border-0" type="text" placeholder="Search" aria-label="Search" />
            </div>
        </header>
    );
};

export default Header;
